export const REJECTED_BY_USER = 'User rejected the request'
export const REJECTED_BY_USER_SHOW = 'User denied transaction signature\nPlease try again'
export const NOT_ENOUGH_FUNDS = '(gas * gas fee + value)'
export const NOT_ENOUGH_FUNDS_SHOW = 'Your matic balance is low to perform transaction, please top-up your account'
